var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "staticNotify",
      style: { backgroundColor: _vm.bgColor, borderColor: _vm.brColor },
    },
    [
      _c("div", { staticClass: "vc" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "i",
            {
              staticClass: "iconfont",
              style: { color: _vm.brColor, fontSize: "16px" },
            },
            [_vm._v("")]
          ),
        ]),
        _c("div", { staticClass: "right" }, [_vm._t("content")], 2),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }